import pro1 from "../assets/project1.png";
import pro2 from "../assets/project2.png";

const ProjectCardData = [
  {
    imgsrc: pro1,
    title: "KnowQuest (Points Marketplace)",
    text: "A dynamic rewards platform where users can:",
    subText: [
      "Accumulate points through referrals and engagements",
      "Unlock premium rewards and exclusive benefits",
      "Drive community growth through sustained interactions",
    ],
    view: "https://knowquest.vercel.app/",
    source: "#",
    tags: ["React", "Node.js", "JavaScript", "HTML", "CSS", "Bootstrap"],
  },
  {
    imgsrc: pro2,
    title: "Black Students Foundation",
    text: "An NGO to help and support black students in Canada",
    subText: [
      "Supports Black students through food, education, and mentorship",
      "Raises awareness about food insecurity and community needs",
      "Responsive design with blog updates and contact features",
    ],

    view: "https://black-students-foundation.vercel.app/",
    source: "#",
    tags: ["React", "CSS", "JavaScript", "HTML"],
  },
];

export default ProjectCardData;
